import React from 'react';
import { Award } from 'lucide-react';

export const hasPerformanceScore = (score, bookingsCount = 0) => {
  const value = Number(score);
  return Number.isFinite(value) && value > 0 && Number(bookingsCount) > 0;
};

export const getPerformanceLabel = (score) => {
  const value = Number(score);
  if (!Number.isFinite(value) || value <= 0) return null;
  if (value >= 85) return 'Top performer';
  if (value >= 70) return 'Highly rated';
  return 'Trusted vendor';
};

const sizeClasses = {
  sm: 'text-[10px] px-2 py-0.5 gap-1',
  md: 'text-xs px-2.5 py-1 gap-1',
};

const VendorPerformanceBadge = ({
  score,
  bookingsCount = 0,
  size = 'sm',
  showLabel = true,
  className = '',
}) => {
  if (!hasPerformanceScore(score, bookingsCount)) {
    return null;
  }

  const value = Number(score);
  const label = getPerformanceLabel(value);

  return (
    <span
      className={`inline-flex items-center rounded-full font-medium bg-emerald-50 text-emerald-800 border border-emerald-200 ${sizeClasses[size]} ${className}`}
      title={`Platform performance score: ${value.toFixed(0)}/100 based on recent bookings`}
    >
      <Award className={size === 'md' ? 'w-3.5 h-3.5' : 'w-3 h-3'} />
      {showLabel && label ? (
        <span>{label}</span>
      ) : (
        <span>{value.toFixed(0)}</span>
      )}
    </span>
  );
};

export default VendorPerformanceBadge;
